module.exports = "images/12ans.754aa6ca.png";